module.exports = __webpack_public_path__ + "img/vertical_3_4_3016.e92c3b8a.png";